import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Worker } from "@react-pdf-viewer/core";
import Main from "./pages/Main/Main";
import Mainshow from "./pages/Main/Mainshow";
import Home from "./pages/Home/Home";
import Expired from "./pages/Expired/Expired";
function App() {
  return (
    <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.15.349/pdf.worker.min.js">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign" element={<Main />} />
          <Route path="/signature" element={<Mainshow />} />
          <Route path="/expired" element={<Expired />} />
        </Routes>
      </BrowserRouter>
    </Worker>
  );
}

export default App;
